module.exports = __webpack_public_path__ + "static/img/hbd2.996ecf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/hbd2.png
// module id = JYMs
// module chunks = 0